import { TableContainer } from "@/components/table-container";
import { Tab } from "@renderbus/ui";
import { TabsSwitch } from "@/pages/consumption/view/billing-details/components/tabs-switch";
import { VolumeDetail } from "@/pages/consumption/view/billing-details/view/volume-detail";
import { PictureMember } from "@/pages/consumption/view/billing-details/view/picture-member";
import { Machine } from "@/pages/consumption/view/billing-details/view/machine";
import { DesktopVolumeDetail } from "@/pages/consumption/view/billing-details/view/desktop-volume-detail";
import styled from "styled-components";
import { useGlobalStore } from "@/store/GlobalStore";
import { MemberRechargeStatus } from "project-config/constants";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useConsumeStore } from "@/pages/consumption/store/ConsumeStore";
import { BillDetailsTabsKey } from "../../constants";
import { useMemo } from "react";
import { useSearchConfig } from "./view/machine/hooks/useSearch";

const t = getTranslateNsT("center");

function BillingDetailsView() {
  const { userInfo, isPictureUser } = useGlobalStore();
  const { billDetailsActiveKey, setBillDetailsActiveKey } = useConsumeStore();
  const { machineOptions } = useSearchConfig();

  const _tabList = useMemo(() => {
    const list = [
      {
        label: t("consumption_task_tab"),
        key: BillDetailsTabsKey.VolumeDetail,
        component: <VolumeDetail />,
      },
    ];

    if (userInfo?.memberRechargeStatus === MemberRechargeStatus.Paid) {
      const PictureMemberItem = {
        label: t("consumption_buy_renderings_tab"),
        key: BillDetailsTabsKey.PictureMember,
        component: <PictureMember />,
      };
      list.push(PictureMemberItem);
    }
    if (machineOptions?.length && machineOptions?.length > 0) {
      const MachineItem = {
        label: t("consumption_machine_tab"),
        key: BillDetailsTabsKey.Machine,
        component: <Machine />,
      };
      list.push(MachineItem);
    }
    if (userInfo?.enableRemoteDesktop && isPictureUser) {
      const DesktopVolumeDetailItem = {
        label: t("tab_desktop") || "",
        key: BillDetailsTabsKey.DesktopVolumeDetail,
        component: <DesktopVolumeDetail />,
      };
      list.push(DesktopVolumeDetailItem);
    }
    return list;
  }, [
    userInfo?.memberRechargeStatus,
    userInfo?.enableRemoteDesktop,
    machineOptions,
    isPictureUser,
  ]);
  return (
    <TableContainer noGap>
      <SubTabWrapper className="animation">
        {_tabList.length > 1 && (
          <Tab
            tabBarExtraContent={{
              left: (
                <TabsSwitch
                  list={_tabList}
                  active={billDetailsActiveKey}
                  setActive={setBillDetailsActiveKey}
                />
              ),
            }}
          />
        )}
        {_tabList.find((item) => item.key === billDetailsActiveKey)?.component}
      </SubTabWrapper>
    </TableContainer>
  );
}

export function RenderBillingDetails() {
  return <BillingDetailsView />;
}

const SubTabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  &.animation {
    .ant-tabs.ant-tabs-top .ant-tabs-nav {
      height: 22px;
    }
    .ant-tabs-extra-content {
      > div {
        background: unset;
        > div {
          background: unset;
          padding: 3px 8px;
          position: relative;
          &.active {
            &::after {
              content: "";
              position: absolute;
              bottom: -6px;
              left: 50%;
              width: 50%;
              height: 1px;
              transform: translate(-50%, 0);
              border-bottom: 1px solid ${(p) => p.theme["theme-5"]};
            }
          }
        }
      }
    }
  }
`;
